/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CheckFlagCondition {
    ANY_ANTENNA_B = 'anyAntennaB',
    ALL_ANTENNAS_B = 'allAntennasB',
    ANY_ANTENNA_A = 'anyAntennaA',
    ALL_ANTENNAS_A = 'allAntennasA',
    ANY_ANTENNA_BIN_ZONE1 = 'anyAntennaBInZone1',
    ANY_ANTENNA_BIN_ZONE2 = 'anyAntennaBInZone2',
    ANY_ANTENNA_B_NOT_IN_ZONES = 'anyAntennaBNotInZones',
    ALL_ANTENNAS_BIN_ZONE1 = 'allAntennasBInZone1',
    ALL_ANTENNAS_BIN_ZONE2 = 'allAntennasBInZone2',
    ALL_ANTENNAS_B_NOT_IN_ZONES = 'allAntennasBNotInZones',
    ANY_ANTENNA_AIN_ZONE1 = 'anyAntennaAInZone1',
    ANY_ANTENNA_AIN_ZONE2 = 'anyAntennaAInZone2',
    ANY_ANTENNA_A_NOT_IN_ZONES = 'anyAntennaANotInZones',
    ALL_ANTENNAS_AIN_ZONE1 = 'allAntennasAInZone1',
    ALL_ANTENNAS_AIN_ZONE2 = 'allAntennasAInZone2',
    ALL_ANTENNAS_A_NOT_IN_ZONES = 'allAntennasANotInZones'
}


export function instanceOfCheckFlagCondition(value: any): boolean {
    for (const key in CheckFlagCondition) {
        if (Object.prototype.hasOwnProperty.call(CheckFlagCondition, key)) {
            if (CheckFlagCondition[key as keyof typeof CheckFlagCondition] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CheckFlagConditionFromJSON(json: any): CheckFlagCondition {
    return CheckFlagConditionFromJSONTyped(json, false);
}

export function CheckFlagConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckFlagCondition {
    return json as CheckFlagCondition;
}

export function CheckFlagConditionToJSON(value?: CheckFlagCondition | null): any {
    return value as any;
}

export function CheckFlagConditionToJSONTyped(value: any, ignoreDiscriminator: boolean): CheckFlagCondition {
    return value as CheckFlagCondition;
}

